import React, { useState, useEffect } from "react";
import {
  Typography,
  Grid2,
  Button,
  useMediaQuery,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box,
} from "@mui/material";
import { useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";

import tp_icon_svg from "../../Assets/Images/trade_icon.svg";
import dip_icon_svg from "../../Assets/Images/diplomats_icon_svg.svg";
import er_icon_svg from "../../Assets/Images/expert_icon_svg.svg";
import wv_icon_svg from "../../Assets/Images/wealth_icon_svg.svg";
import tp_icon from "../../Assets/trade.gif";
import dip_icon from "../../Assets/Diplomats.gif";
import exp_icon from "../../Assets/ExpertRecommendation.gif";
import wealth_vault_icon from "../../Assets/WealthVaults.gif";
import TBlogo from '../../ui-utils/latestPics/Footer.svg';
import bull from "../../Assets/Images/TB_loginLogo1.svg";
import overlay from "../../ui-utils/latestPics/loginoverlay.svg"; // Adjust the path
import { backendHosts } from "../../ui-utils/apiConfig"
import styles from "./LoginWeb.module.css"; // Import the CSS module
import bb from "../../ui-utils/latestPics/bb.svg"
import DocumentMeta from 'react-document-meta'
const meta = {
  title: 'Secure Login Access to Your Trading Account | TradeBoss',
  description: 'Login to TradeBoss for fast, secure access to your trading account. Trade NSE, BSE stocks, bonds & IPOs anytime with complete confidence.',
  canonical: 'https://tradeboss.co/login',
  meta: {
    charset: 'utf-8',
    name: {
      keywords: 'tradeboss login, trading platform login, demat account login, secure login tradeboss, login trading app, access trading account'
    }
  }
}
const LoginWeb = () => {
  const theme = useTheme();
  // const range = useMediaQuery(theme.breakpoints.between(601, 849));

  const isLargeScreen = useMediaQuery("(max-width:1564px)");
  const screenWidth1300 = useMediaQuery("(max-width:1300px)");

  const navigate=useNavigate()

  const [t1, setT1] = useState(1);
  const [isTHovered, setIsTHovered] = useState(false);
  const [isDHovered, setIsDHovered] = useState(false);
  const [isEHovered, setIsEHovered] = useState(false);
  const [isWHovered, setIsWHovered] = useState(false);

  const handleLogin = () => {
    console.log("clicked");
    console.log(t1);

    const isStaging = window.location.href.includes("staging") || window.location.href.includes("localhost");
    let expertLink
    let wealthVaultLink
    if(isStaging){

             expertLink=" https://expert-recommendation-frontend-staging.tradeboss.co/"
             wealthVaultLink="https://wealthvault-frontend-staging.tradeboss.co/"
    }else{
             expertLink="  https://expert-recommendation-frontend.tradeboss.co/"
             wealthVaultLink="https://wealthvault-frontend.tradeboss.co/"
    }
    if(t1 == 1){
      console.log("trading Platform")
      window.open(backendHosts.TRADEPLF, '_blank');
    }

    else if (t1 == 2) {
      window.open(backendHosts.BACKOFFICE, '_blank');
    } else if(t1 == 3){

      window.open(expertLink, '_blank');
      // window.location.href = expertLink;
    }
    else if(t1 == 4){
      window.open(wealthVaultLink, '_blank');
      // window.location.href = wealthVaultLink;
    }
  };

  const handleSignUp=()=>{
    const isStaging = window.location.href.includes("staging") || window.location.href.includes("localhost");

console.log(isStaging)
    const baseUrl = isStaging
      ? "https://kyc-frontend-staging.tradeboss.co"
      : "https://kyc.tradeboss.co";

      window.location.href = baseUrl;
  }

  return (
    // <Box className={styles.HomeSectionBox}>
    //   <DocumentMeta {...meta} />

    //   <Grid2
    //     container
    //     sx={{
    //       width: "100%",
    //       height: "100vh", // Full screen height
    //       display: "flex",
    //       flexDirection: { xs: "column", md: "row" },
    //     }}
    //   >



    //     <Grid2
    //       sx={{
    //         flex: 1,
    //         position: "relative",
    //         overflow: "hidden",
    //         height: "100%",
    //       }}


    //     >
    //       <Box
    //         component="video"
    //         autoPlay
    //         loop
    //         muted
    //         playsInline
    //         controls={false}
    //         sx={{
    //           position: "absolute",
    //           top: 0,
    //           left: 0,
    //           width: "100%",
    //           height: "100%",
    //           objectFit: "cover",
    //           pointerEvents: "none",
    //           '&::-webkit-media-controls': {
    //             display: 'none !important',
    //             opacity: 0,
    //           },
    //         }}
    //       >
    //         <source src={bg} type="video/mp4" />
    //       </Box>


    //     </Grid2>

    //     <Grid2
    //       sx={{
    //         flex: 1,
    //         display: "flex",
    //         justifyContent: "center",
    //         alignItems: "center",
    //         flexDirection: "column",
    //         gap: "2rem",
    //         background:
    //           "linear-gradient(252.52deg, #110A0A 9.37%, #3B282F 47.3%, #262734 73.59%, #12131C 99.03%);",
    //         padding: "2rem",
    //         position: "relative", // Add this
    //         overflow: "hidden",
    //       }}
    //     >
    //       <Box
    //         component="img"
    //         src={overlay}
    //         alt="Top illustration"
    //         sx={{
    //           position: "absolute",
    //           top: 0,
    //           left: 0,
    //           width: "100%",
    //           height: "40%", // 🔹 only top half
    //           objectFit: "cover",
    //         }}
    //       />


    //     </Grid2>


    //   </Grid2>
    // </Box>


    <Box className={styles.HomeSectionBox}>
      <DocumentMeta {...meta} />

      {/* Background Section */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: 1,
        }}
      >
        <Grid2
          container
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
          }}
        >
          {/* Video Section */}
          <Grid2 sx={{ flex: 1, position: "relative", overflow: "hidden", height: "100%" }}>
            <Box sx={{ position: "absolute", inset: 0 }}>
              <img src={bb} alt="Background slideshow" className={styles.bgImage} />
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  background: "linear-gradient(360deg, #110A0A 0%, #352E36 48.91%, #161720 109.39%)",
                  zIndex: 0,
                }}
              />
            </Box>

          </Grid2>

          {/* Gradient + Overlay Section */}
          <Grid2
            sx={{
              flex: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              gap: "2rem",
              background:
                "linear-gradient(252.52deg, #110A0A 9.37%, #3B282F 47.3%, #262734 73.59%, #12131C 99.03%)",
              padding: "2rem",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <Box
              component="img"
              src={overlay}
              alt="Top illustration"
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "40%",
                objectFit: "cover",
                opacity: 0.3,
              }}
            />
          </Grid2>
        </Grid2>
      </Box>

      {/* Content Section (appears above background) */}
      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          width: "100%", // parent can be full width
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          // margin: "127px 146px 100px 158px",
          "@media (max-height: 700px)": {
            alignItems: "flex-start",
            marginTop:"50px"
          },

        }}
      >

        <Grid2
          sx={{
            width: "fit-content", // only as wide as its children
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            background: "#FFFFFF1A",

            borderRadius: "24px",
            backdropFilter: "blur(20px)",
            padding:"0px 0px 0px 34px",
            gap:"156px",

            "@media (max-width: 1400px)": {
              gap: "106px",
            },
           }}

          // sx={{
          //   display: "flex",
          //   flexDirection: "row",
          //   justifyContent: "flex-start", // left-align inner cards
          //   alignItems: "flex-start",
          //   background: "#FFFFFF1A",
          //   borderRadius: "12px",
          //   backdropFilter: "blur(20px)",
          //   padding: "20px", // optional: inner spacing
          //   gap: "0", // no extra space between children
          //   width: "max-content", // grows to fit combined width of inner cards
          //   margin: "0 auto", // center the entire blurred card on page
          // }}
        >


        <Grid2
          sx={{

            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            // margin: "0px",
            // "@media screen and (max-width:1740px)": {
            //   marginLeft: "100px",
            // },

            // "@media screen and (max-width:1500px)": {
            //   marginLeft: "80px",
            // },
            // "@media screen and (max-width:1400px)": {
            //   maxWidth: "450px",
            // },
          }}
        >
          <Grid2
            // container
            sx={{

                background: "linear-gradient(180deg, rgba(29, 31, 47, 0.8) 0%, rgba(15, 14, 21, 0.8) 100%)",
              maxHeight: "400px",
              maxWidth: "487px",
              borderRadius: "28px",
              display: "flex",
              flexDirection: "column", // Ensures content is stacked
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center", // Centers text
              padding: "130px", // Adds spacing inside the container



            }}
            className={styles.largeLogoCard}
          >
            <Box
              component="img"
              onClick={() => {
                navigate("/");
                window.scrollTo(0, 0);
              }}
              src={TBlogo}
              alt="Logo"
              sx={{
                width: "287px",
                height: "auto",
                cursor: "pointer"

              }}
            />


          </Grid2>
        </Grid2>

        <Grid2
          style={{
              width: "550px",
            // minHeight: "700px",
            display: "flex",
            alignItems: "center",
            justifyContent: "left",
          }}
        >
          <Grid2
            container
            sx={{
              // height: isLargeScreen ? "680px" : "750px",

              // border: window.innerWidth < 849 ? "none" : "none",
              padding: "15px 0px 15px",
              // width: "90%",
              borderRadius: "28px",
              "@media screen and (max-width:1500px)": {
                padding: "15px 0px"
              },
            }}
            className={styles.loginCard}
          >


            <Grid2
              style={{
                width: "70%",
                marginTop: "3%",
                marginLeft: "15%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              className={styles.LoginnowGrid}
            >
              <Typography className={styles.card_tit}>Login now</Typography>
            </Grid2>


            <Grid2
              style={{
                width: "100%",
                height:"62px",
                marginTop: "3%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Grid2
                className={
                  t1 === 1 ? styles.sel_button : styles.sel_button_dis
                }
                onClick={() => setT1(1)}
                onMouseEnter={() => setIsTHovered(true)}
                onMouseLeave={() => setIsTHovered(false)}
              >
                <Grid2
                  container
                  style={{
                    width: "15%",
                    display: "flex",
                    justifyContent: "center",
                    alignContent: "center",
                  }}
                >
                  <div
                    style={{
                      borderRadius: "50%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div className={styles.imageContainer}>
                      <img
                        src={tp_icon_svg}
                        alt="bulllogo"
                        className={styles.svgImage}
                        style={{ opacity: isTHovered ? 0 : 1 }}
                      />
                      <img
                        src={tp_icon}
                        alt="bulllogo"
                        className={styles.gifImage}
                        style={{ opacity: isTHovered ? 1 : 0 }}
                      />
                    </div>
                  </div>
                </Grid2>
                <Grid2
                  container
                  style={{
                    width: "75%",
                    marginLeft: "3%",
                    justifyContent: "start",
                    alignContent: "center",
                  }}
                >
                  <Typography className={t1 === 1 ? styles.d1 : styles.d2}>
                    Trading Platform
                  </Typography>
                </Grid2>
                {t1 === 1 && (
                  <Grid2 style={{ width: "10%", alignContent: "center" }}>
                    <RadioGroup row defaultValue="indian">
                      <FormControlLabel
                        value="indian"
                        control={
                          <Radio
                            inputProps={{
                              "aria-label": "Indian",
                            }}
                            disableRipple
                            size="small"
                            checked
                            sx={{
                              color: "#999999",
                              "&.Mui-checked": {
                                position: "relative",
                                "&::before": {
                                  content: '""',
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                  transform: "translate(-50%, -50%)",
                                  width: "24px",
                                  height: "24px",
                                  borderRadius: "50%",
                                  backgroundColor: "#17164F", // Outer circle color
                                  border: "2px solid #F3D45E", // Yellow border
                                },
                                "&::after": {
                                  content: '""',
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                  transform: "translate(-50%, -50%)",
                                  width: "12px",
                                  height: "12px",
                                  borderRadius: "50%",
                                  backgroundColor: "#F3D45E", // Inner circle color
                                },
                                "& .MuiSvgIcon-root": {
                                  visibility: "hidden", // Hide default radio button
                                },
                              },
                            }}
                          />
                        }
                      />
                    </RadioGroup>
                  </Grid2>
                )}
              </Grid2>
            </Grid2>


            {/* <Grid2
              style={{
                width: "100%",
                marginTop: "3%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Grid2
                className={
                  t1 === 2 ? styles.sel_button : styles.sel_button_dis
                }
                onClick={() => setT1(2)}
                onMouseEnter={() => setIsDHovered(true)}
                onMouseLeave={() => setIsDHovered(false)}
              >
                <Grid2
                  container
                  style={{
                    width: "15%",
                    display: "flex",
                    justifyContent: "center",
                    alignContent: "center",
                  }}
                >
                  <div
                    style={{
                      borderRadius: "50%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div className={styles.imageContainer}>
                      <img
                        src={dip_icon_svg}
                        alt="bulllogo"
                        className={styles.svgImage}
                        style={{ opacity: isDHovered ? 0 : 1 }}
                      />
                      <img
                        src={dip_icon}
                        alt="bulllogo"
                        className={styles.gifImage}
                        style={{ opacity: isDHovered ? 1 : 0 }}
                      />
                    </div>
                  </div>
                </Grid2>
                <Grid2
                  container
                  style={{
                    width: "75%",
                    marginLeft: "3%",
                    justifyContent: "start",
                    alignContent: "center",
                  }}
                >
                  <Typography className={t1 === 2 ? styles.d1 : styles.d2}>
                    Backoffice
                  </Typography>
                </Grid2>
                {t1 === 2 && (
                  <Grid2 style={{ width: "10%", alignContent: "center" }}>
                    <RadioGroup row defaultValue="indian">
                      <FormControlLabel
                        value="indian"
                        control={
                          <Radio
                            disableRipple
                            size="small"
                            checked
                            sx={{
                              color: "#999999",
                              "&.Mui-checked": {
                                position: "relative",
                                "&::before": {
                                  content: '""',
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                  transform: "translate(-50%, -50%)",
                                  width: "24px",
                                  height: "24px",
                                  borderRadius: "50%",
                                  backgroundColor: "#17164F", // Outer circle color
                                  border: "2px solid #F3D45E", // Yellow border
                                },
                                "&::after": {
                                  content: '""',
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                  transform: "translate(-50%, -50%)",
                                  width: "12px",
                                  height: "12px",
                                  borderRadius: "50%",
                                  backgroundColor: "#F3D45E", // Inner circle color
                                },
                                "& .MuiSvgIcon-root": {
                                  visibility: "hidden", // Hide default radio button
                                },
                              },
                            }}
                          />
                        }
                      />
                    </RadioGroup>
                  </Grid2>
                )}
              </Grid2>
            </Grid2> */}


            <Grid2
              style={{
                width: "100%",
                marginTop: "3%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Grid2
                className={
                  t1 === 3 ? styles.sel_button : styles.sel_button_dis
                }
                onClick={() => setT1(3)}
                onMouseEnter={() => setIsEHovered(true)}
                onMouseLeave={() => setIsEHovered(false)}
              >
                <Grid2
                  container
                  style={{
                    width: "15%",
                    display: "flex",
                    justifyContent: "center",
                    alignContent: "center",
                  }}
                >
                  <div
                    style={{
                      borderRadius: "50%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div className={styles.imageContainer}>
                      <img
                        src={er_icon_svg}
                        alt="bulllogo"
                        className={styles.svgImage}
                        style={{ opacity: isEHovered ? 0 : 1 }}
                      />
                      <img
                        src={exp_icon}
                        alt="bulllogo"
                        className={styles.gifImage}
                        style={{ opacity: isEHovered ? 1 : 0 }}
                      />
                    </div>
                  </div>
                </Grid2>
                <Grid2
                  container
                  style={{
                    width: "75%",
                    marginLeft: "3%",
                    justifyContent: "start",
                    alignContent: "center",
                  }}
                >
                  <Typography className={t1 === 3 ? styles.d1 : styles.d2}>
                    Expert Recommendation
                  </Typography>
                </Grid2>
                {t1 === 3 && (
                  <Grid2 style={{ width: "10%", alignContent: "center" }}>
                    <RadioGroup row defaultValue="indian">
                      <FormControlLabel
                        value="indian"
                        control={
                          <Radio
                            inputProps={{
                              "aria-label": "Indian",
                            }}
                            disableRipple
                            size="small"
                            checked
                            sx={{
                              color: "#999999",
                              "&.Mui-checked": {
                                position: "relative",
                                "&::before": {
                                  content: '""',
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                  transform: "translate(-50%, -50%)",
                                  width: "24px",
                                  height: "24px",
                                  borderRadius: "50%",
                                  backgroundColor: "#17164F", // Outer circle color
                                  border: "2px solid #F3D45E", // Yellow border
                                },
                                "&::after": {
                                  content: '""',
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                  transform: "translate(-50%, -50%)",
                                  width: "12px",
                                  height: "12px",
                                  borderRadius: "50%",
                                  backgroundColor: "#F3D45E", // Inner circle color
                                },
                                "& .MuiSvgIcon-root": {
                                  visibility: "hidden", // Hide default radio button
                                },
                              },
                            }}
                          />
                        }
                      />
                    </RadioGroup>
                  </Grid2>
                )}
              </Grid2>
            </Grid2>


            <Grid2
              style={{
                width: "100%",
                marginTop: "3%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Grid2
                className={
                  t1 === 4 ? styles.sel_button : styles.sel_button_dis
                }
                onClick={() => setT1(4)}
                onMouseEnter={() => setIsWHovered(true)}
                onMouseLeave={() => setIsWHovered(false)}
              >
                <Grid2
                  container
                  style={{
                    width: "15%",
                    display: "flex",
                    justifyContent: "center",
                    alignContent: "center",
                  }}
                >
                  <div
                    style={{
                      borderRadius: "50%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div className={styles.imageContainer}>
                      <img
                        src={wv_icon_svg}
                        alt="bulllogo"
                        className={styles.svgImage}
                        style={{ opacity: isWHovered ? 0 : 1 }}
                      />
                      <img
                        src={wealth_vault_icon}
                        alt="bulllogo"
                        className={styles.gifImage}
                        style={{ opacity: isWHovered ? 1 : 0 }}
                      />
                    </div>
                  </div>
                </Grid2>
                <Grid2
                  container
                  style={{
                    width: "75%",
                    marginLeft: "3%",
                    justifyContent: "start",
                    alignContent: "center",
                  }}
                >
                  <Typography className={t1 === 4 ? styles.d1 : styles.d2}>
                    Wealth Vaults
                  </Typography>
                </Grid2>
                {t1 === 4 && (
                  <Grid2 style={{ width: "10%", alignContent: "center" }}>
                    <RadioGroup row defaultValue="indian">
                      <FormControlLabel
                        value="indian"
                        control={
                          <Radio
                            inputProps={{
                              "aria-label": "Indian",
                            }}
                            disableRipple
                            size="small"
                            checked
                            sx={{
                              color: "#999999",
                              "&.Mui-checked": {
                                position: "relative",
                                "&::before": {
                                  content: '""',
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                  transform: "translate(-50%, -50%)",
                                  width: "24px",
                                  height: "24px",
                                  borderRadius: "50%",
                                  backgroundColor: "#17164F", // Outer circle color
                                  border: "2px solid #F3D45E", // Yellow border
                                },
                                "&::after": {
                                  content: '""',
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                  transform: "translate(-50%, -50%)",
                                  width: "12px",
                                  height: "12px",
                                  borderRadius: "50%",
                                  backgroundColor: "#F3D45E", // Inner circle color
                                },
                                "& .MuiSvgIcon-root": {
                                  visibility: "hidden", // Hide default radio button
                                },
                              },
                            }}
                          />
                        }
                      />
                    </RadioGroup>
                  </Grid2>
                )}
              </Grid2>
            </Grid2>


            <Grid2
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignContent: "center",
              }}
            >
              <Grid2
                style={{
                  width: "70%",
                  display: "flex",
                  justifyContent: "center",
                  alignContent: "center",
                }}
              >
                <Button
                  fullWidth
                  className={styles.joinDiplomtsBtn}
                  style={{ marginTop: "41px" }}
                  onClick={handleLogin}
                >
                  Login
                </Button>
              </Grid2>
            </Grid2>


            <Grid2
              style={{
                marginTop: "3%",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                marginBottom: "47px",
              }}
              className={styles.DonntStyle}
            >
              <Typography className={styles.d3}>
                Don’t have an account?{" "}
              </Typography>
              <Typography
                className={styles.d4}
                sx={{ marginLeft: "1%", cursor: "pointer !important" }}
                onClick={handleSignUp}
              >
                Register
              </Typography>
            </Grid2>
          </Grid2>
        </Grid2>

        </Grid2>
      </Box>
    </Box>

  );
};

export default LoginWeb;
